import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=18b236b0&scoped=true&"
import script from "./message-center.vue?vue&type=script&lang=js&"
export * from "./message-center.vue?vue&type=script&lang=js&"
import style0 from "./message-center.vue?vue&type=style&index=0&id=18b236b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b236b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b236b0')) {
      api.createRecord('18b236b0', component.options)
    } else {
      api.reload('18b236b0', component.options)
    }
    module.hot.accept("./message-center.vue?vue&type=template&id=18b236b0&scoped=true&", function () {
      api.rerender('18b236b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/message-center.vue"
export default component.exports